import type {
  PropsWithChildren,
  ReactElement,
} from 'react';
import styled from 'styled-components';

import { CloseButton } from './CloseButton';
import { Clearfix } from './Clearfix';
import { modalSizes } from './modalSizes';
import type {
  ModalSize,
} from './types';

const mapToThemeSizes: Record<ModalSize, 'WIDTH_DEFAULT' | 'WIDTH_TINY' | 'WIDTH_SMALL' | 'WIDTH_LARGE'> = {
  [modalSizes.DEFAULT]: 'WIDTH_DEFAULT',
  [modalSizes.TINY]: 'WIDTH_TINY',
  [modalSizes.SMALL]: 'WIDTH_SMALL',
  [modalSizes.LARGE]: 'WIDTH_LARGE',
};

export const StyledDialog = styled(Clearfix)<{
  size?: ModalSize;
  hasMargins: boolean;
}>(({
  size,
  hasMargins,

  theme: {
    colors,
    modal,
  },
}) => ({
  width: modal[mapToThemeSizes[size ?? modalSizes.DEFAULT]],
  position: 'relative',
  margin: hasMargins ? '104px auto' : undefined,
  borderRadius: 4,
  backgroundColor: colors.NEUTRAL_WHITE,
  boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.3)',
  outline: 'none',
}));

export type ModalDialogProps = PropsWithChildren<{
  size?: ModalSize;
  hasCloseButton?: boolean;
  onHide: () => void;
  hasMargins?: boolean;
}>;

export function ModalDialog({
  size = modalSizes.DEFAULT,
  hasCloseButton = true,
  hasMargins = true,
  children = undefined,
  onHide,
}: ModalDialogProps): ReactElement {
  return (
    <StyledDialog
      size={size}
      hasMargins={hasMargins}
    >
      {
        hasCloseButton && (
          <CloseButton
            onClick={onHide}
          />
        )
      }

      {children}
    </StyledDialog>
  );
}
